import { render, staticRenderFns } from "./CustomVars.vue?vue&type=template&id=3218dcac"
import script from "./CustomVars.vue?vue&type=script&lang=js"
export * from "./CustomVars.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports